export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11584.ca312266.jpg";